<template>
  <div v-if="$parent.options && $parent.options.title"
    class="input-title" :class="{ required }">
    {{ $parent.options.title }}
    <el-tooltip v-if="description" :content="description" placement="top">
      <i class="el-icon-question"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['required', 'description'],
};
</script>

<style lang="scss">
.input-title {
  font-size: 18px;
  line-height: 22px;
  color: #ededed;
  text-align: left;
  padding-bottom: 20px;
  &.required:before {
    content: '*';
    color: #ffacac;
    display: inline-block;
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/elements/InputTitle.vue